import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditCourse = props => {
  const { courseId } = props.params

  return (
    <Edit
      title='Edit Course'
      fields={fields}
      apiPath={`admin/courses/${courseId}`}
      successRedirectPath='/events/courses'
      buildMenuItems={menuItems}
    />
  )
}

export default EditCourse
